import React from 'react';
import { Star } from 'lucide-react';
export function SocialProof() {
  return <div className="bg-brand-surface border-y border-brand-border py-4" data-id="element-182">
      <div className="max-w-4xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-center gap-4 text-center sm:text-left" data-id="element-183">
        <div className="flex gap-1" data-id="element-184">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-brand-green text-brand-green" data-id="element-185" />)}
        </div>
        <p className="text-lg md:text-xl font-semibold text-brand-text" data-id="element-186">
          <span className="text-brand-green font-bold" data-id="element-187">+2.500 jugadores</span>{' '}
          ya entrenan con el sistema
        </p>
      </div>
    </div>;
}